// src/view/login/auto.jsx

import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { loginAuto } from "../../store/actions/userActions"; // Ajusta ruta si es distinta

const LoginAuto = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const [error, setError] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("data");
    //console.log('Token recibido: ' + token)

    if (token) {
      dispatch(loginAuto(token)).then((response) => {
        if (response?.type === "USER/LOGIN_USER_SUCCESS") {
          history.push("/");
        } else {
          setError("Error en el login automático.");
        }
      });
    } else {
      setError("Falta el parámetro 'data' en la URL.");
    }
  }, [dispatch, location.search, history]);

  return (
    <div className="container">
      <div className="row justify-content-center align-items-center">
        <div className="loginContainer col-md-5">
          <h2>Procesando login automático...</h2>
          {error && (
            <div className="alert alert-danger mt-3">{error}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoginAuto;
